import React from "react";
// import Countdown from "react-countdown";
import Countdown from "react-countdown-now";
// import Loader from '../../Shared/Loader';
import { toast } from "react-toastify";
import Axios from "../../../Axios";
import { Urls } from "../../../Urls";
// import { useHistory } from 'react-router-dom'
import { currentRequestTimeStamp } from "../../../Constants";
import classes from "./RemainingTime.module.css";
import { updateAuctionStatus } from "../../../Utility";
// import { db_time_stamp } from '../../../Utility';

const RemainingTime = ({
  screen,
  paused_timestamp,
  date,
  id,
  auction_paused,
  starttime,
  setStarttime,
  auction_closed,
  offset,
  setauctionClosed,
  setAuctionpaused,
  setreload_timer,
  setTimerKey,
  timerKey,
  reload_timer,
  setpaused_timestamp,
  getAuctionDetails,
  bucket,
  status,
}) => {
  // Renderer callback with condition
  const renderer = ({ days, hours, minutes, seconds, completed }) => {
    
    // Check if the auction is closed
    if (status === "closed" || auction_closed === true) {
        // if (completed) {
      // Render a completed state
      // return <Completionist />;
      //   return null
      return (
        <button
          className={`btn ${classes['Timer-Button']} ${hours === 0 && minutes < 3 && seconds < 59 ? classes['blink_me'] : 'btn-success'}`}
        >
          <i style={{ fontSize: "2em" }} className="fa fa-clock"></i><br />
          <span>Closed</span>
        </button>
      );
    } //check if status is closed
    // else if (status === "closed") {
    //   return (
    //     <>
    //       <button
    //         className={`btn ${classes["Timer-Button"]} ${
    //           hours === 0 && minutes === 0 && seconds < 59
    //             ? classes["blink_me"]
    //             : "btn"
    //         }`}
    //       >
    //         <i style={{ fontSize: "2em" }} className="fa fa-clock"></i> <br />
    //         <span>{"Closed"}</span>
    //       </button>
    //     </>
    //   );
    // } 
    //check if status is none
    else if (
      status !== "active" &&
      status !== "closed" &&
      status !== "paused"
    ) {
      return "NA";
    }
    // Check if we need to display a loading spinner
    else if ((offset === undefined || offset === null || !date) && !auction_paused) {
      return (
          <button className={`btn ${classes["Timer-Button"]}`}>
          <div className="d-flex align-items-center">
            <div class="spinner-border spinner-border-sm" role="status">
              <span class="sr-only">Loading...</span>
            </div>
            <span className="ml-1"> Loading...</span>
          </div>
        </button>
      );
    }else {
  
    // Render the countdown timer
    return (
        <center>
      <button
            className={`btn d-flex align-items-center ${classes["Timer-Button"]} ${
            hours === 0 && minutes === 0 && seconds < 59
              ? classes["blink_me"]
                : "btn"
          }`}
      >
            <i style={{ fontSize: "1em", marginRight:"2%" }} className="fa fa-clock"></i>
            {
            // days >= 0 || hours >= 0 || minutes >= 0 || seconds >= 0 ? 
            days === 0 ?
             (
        <span style={{textWrap:"nowrap"}}>
          {hours} Hours {minutes} Minutes {seconds} Seconds
        </span>
          ) : (
            <span>
              {days} Days {hours} Hours {minutes} Minutes {seconds} Seconds
            </span>
          )
          // : null
          }
      </button>
        </center>
    );
    }
  };
  
  
  // var countertime = starttime
  // const startingtime = () => {
  //     // if(auction_paused){
  //     //     return new Date(starttime)
  //     // }
  //     // else{
  //     //     var newdate = new Date(starttime)
  //     //     newdate.setSeconds(newdate.getSeconds() + 1)
  //     //     countertime=newdate
  //     //     return newdate
  //     // }
  // }

  const countDownOver = () => {
    if(setTimerKey && timerKey){
      setTimerKey(timerKey + 1);
    }
    // if (setAuctionClosed) {
    
      // updateAuctionStatus(id,setAuctionpaused, setAuctionClosed , setreload_timer, reload_timer, setpaused_timestamp)
      //check if auction status is live
      updateAuctionStatus(id,setAuctionpaused, setauctionClosed , setreload_timer, reload_timer, setpaused_timestamp,getAuctionDetails, bucket)

      // setAuctionClosed(true);
    //   Axios.post(`${Urls.messages}/messages`, {
    //     auction_id: location.state.auction_id,
    //     action: "closed_auction",
    //     auction_status: "closed",
    //     close_timestamp: currentRequestTimeStamp(),
    //   })
    //     .then((res) => {
    //       // do nothing
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //       toast.info("bid unsuccessful. Please try again");
    //     });
    // }
  };
  
  return (
    <div>
      {auction_paused ? (
        <Countdown
          key={timerKey}
          date={new Date(new Date(date).toUTCString())}
          now={() => new Date(new Date(paused_timestamp).toUTCString())}
          renderer={renderer}
          // autoStart={true}
          // overtime={true}
        />
      ) : (
        <Countdown
          key={timerKey}
          date={new Date(new Date(date).toUTCString())}
          now={() => new Date().getTime() + offset}
          renderer={renderer}
          onComplete={countDownOver}
          autoStart={true}
          overtime={true}
        />
      )}
    </div>
  );
};

export default RemainingTime;
